import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccountType } from '@toro/common/shared/enum/finance/account-type.enum';
import { StatusTransfer } from '@toro/common/shared/enum/finance/status-transfer.enum';
import { WithdrawHistory } from '@toro/common/shared/models/finance/withdraw-history.model';

enum RejectionReason {
    SaqueDevolvido = '14310',
    BloqueioJudicial = 'BLOQUEIO_JUDICIAL',
    BloqueioAlavancagem  = 'BLOQUEIO_ALAVANCAGEM',
    SemSaldo = 'SEM_SALDO',
    BloqueioRisco = 'BLOQUEIO_RISCO',
    BloqueioSistema = 'BLOQUEIO_SISTEMA'
}
@Component({
    selector: 'app-withdrawal-history-item',
    templateUrl: './withdrawal-history-item.component.html',
    styleUrls: ['./withdrawal-history-item.component.scss'],
    providers: [DatePipe]
})

export class WithdrawalHistoryItem {
    @Input() public withdrawal: WithdrawHistory;

    public active = false;

    public get isMobile(): boolean {
        return window.innerWidth <= 1023;
    }

    constructor(private datePipe: DatePipe) { }

    public getWithdrawalTitle(): string {
        switch (this.withdrawal.statusTransfer) {
            case StatusTransfer.Agendada:
                return 'Aguardando janela de transferência';
            case StatusTransfer.Aprovada:
                return 'Aprovado';
            case StatusTransfer.Rejeitada:
                return 'Rejeitado';
            case StatusTransfer.Finalizada:
                return 'Finalizado';
            case StatusTransfer.Integrada:
                return 'Efetivado';
            case StatusTransfer.CanceladaPeloCliente:
                return 'Cancelado pelo cliente';
            case StatusTransfer.DevolucaoAprovada:
                return 'Devolução aprovada';
            case StatusTransfer.DevolucaoConcluida:
                return 'Devolução concluída';
            case StatusTransfer.SaqueDevolvido:
                return 'Devolvido';
        }
    }

    public getAccountType(): string {
        switch (this.withdrawal.accountType) {
            case AccountType.CheckingAccount:
                return 'Conta corrente';
            case AccountType.SavingsAccount:
                return 'Conta poupança';
            default:
                return '';
        }
    }

    public getWithdrawalDescription(): string {
        switch (this.withdrawal.statusTransfer) {
            case StatusTransfer.Agendada:
                return `O saque será efetivado na próxima janela às ${this.withdrawal.transferTime.substring(0, 5)}.`;
            case StatusTransfer.Rejeitada:
                return this.getRejectionMessage();
            default:
                return '';
        }
    }

    public toggleCard() {
        this.active = !this.active;
    }

    private getRejectionMessage(): string {
        switch ((this.withdrawal.rejectionReason || '').toUpperCase()) {
            case RejectionReason.SaqueDevolvido:
                return 'Motivo: os dados informados da sua conta bancária estão incorretos ou a sua agência pode ter sido desativada.';
            case RejectionReason.BloqueioJudicial:
                return 'Motivo: a sua conta está sob bloqueio judicial.';
            case RejectionReason.BloqueioAlavancagem:
                return 'Motivo: se o saque fosse realizado, um ou mais investimentos seus ficariam alavancados, ' +
                'com chance de serem encerrados compulsoriamente pela equipe de risco.';
            case RejectionReason.SemSaldo:
                return 'Motivo: o seu saldo era insuficiente no momento que tentamos realizar a transferência.';
            case RejectionReason.BloqueioRisco:
                return this.getMessageBloqueioRisco();
            case RejectionReason.BloqueioSistema:
                return 'Por favor, tente novamente ou entre em contato com a Assessoria. ' +
                'A transferência não pôde ser realizada devido a um erro.';
            default:
                return 'Por favor, tente novamente mais tarde ou entre em contato com a Assessoria.';
        }
    }

    private getMessageBloqueioRisco(): string {
        if (this.withdrawal.updatedAt) {
            const date =  this.datePipe.transform(new Date(this.withdrawal.updatedAt), 'dd/MM/yyyy');
            return `Motivo: você tem taxas e impostos a pagar referentes às operações realizadas em ${date}`;
        }

        return 'Motivo: você tem taxas e impostos a pagar referentes às operações realizadas até à data de solicitação do saque.';
    }
}
